import BaseDecorator from "./BaseDecorator";
import OrderedProductOrderFieldDecorator from "./OrderedProductOrderFieldDecorator";
import ProductPricelistItemDecorator from "./ProductPricelistItemDecorator";

export default class OrderedProductPricelistItemDecorator extends BaseDecorator {
  constructor(data) {
    const product_pricelist_item = new ProductPricelistItemDecorator(data.product_pricelist_item);
    super({
      ...data,
      product_pricelist_item,
      quantity: data.quantity || 0,
      persons_count: product_pricelist_item.fits_people ? data.persons_count || 0 : null,
      ordered_product_order_fields: data.ordered_product_order_fields
        .map((x) => new OrderedProductOrderFieldDecorator(x))
        .sort((a, b) => a.product_order_field.position - b.product_order_field.position),
    });
  }

  get priced_ordered_fields() {
    return this.ordered_product_order_fields
      .filter((orderedField) => orderedField.visible)
      .filter((orderedField) => orderedField.product_order_field.has_pricing);
  }

  get customer_ordered_fields() {
    return this.ordered_product_order_fields
      .filter((orderedField) => orderedField.visible)
      .filter((orderedField) => !orderedField.product_order_field.has_pricing);
  }

  get min_quantity() {
    return this.product_pricelist_item.min_quantity ? this.product_pricelist_item.min_quantity : 0;
  }

  get max_quantity() {
    return this.product_pricelist_item.max_quantity ? this.product_pricelist_item.max_quantity : Infinity;
  }

  get min_persons_count() {
    return this.product_pricelist_item.min_persons_count
      ? this.quantity * this.product_pricelist_item.min_persons_count
      : 0;
  }

  get max_persons_count() {
    return this.product_pricelist_item.max_persons_count
      ? this.quantity * this.product_pricelist_item.max_persons_count
      : Infinity;
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/OrderedProductPricelistItemDecorator.js